const { createApp } = Vue

const app = createApp({
  data() {
    return {
      ready: false,
      subnav: 0,
      subSubnav: 0,
      mobileNavOpen: false,
      navType: 'simple',
      mobileExpandedItems: [], // Track expanded parent items on mobile
    }
  },
  mounted() {
    this.isHammesNav()
  },
  methods: {
    openSub(node) {
      this.closeSub()

      if (node.id !== this.subnav.id) {
        this.subSubnav = 0
      }

      this.subnav = node
    },
    toggleMobileNav() {
      this.mobileNavOpen = !this.mobileNavOpen
      
      // Toggle body scroll lock
      if (this.mobileNavOpen) {
        document.body.classList.add('freeze')
      } else {
        document.body.classList.remove('freeze')
        this.closeMobileExpanded() // Close expanded items when menu closes
      }
    },
    toggleMobileParent(nodeId, event) {
      // Only apply on mobile - increased breakpoint to cover more devices
      if (window.innerWidth > 768) return
      
      event.preventDefault()
      event.stopPropagation()
      
      const index = this.mobileExpandedItems.indexOf(nodeId)
      if (index > -1) {
        // Collapse this item - create new array to trigger reactivity
        this.mobileExpandedItems = this.mobileExpandedItems.filter(id => id !== nodeId)
      } else {
        // Expand this item - create new array to trigger reactivity
        this.mobileExpandedItems = [...this.mobileExpandedItems, nodeId]
      }
    },
    isMobileParentExpanded(nodeId) {
      return this.mobileExpandedItems.includes(nodeId)
    },
    closeMobileExpanded() {
      this.mobileExpandedItems = []
    },
    closeSub() {
      this.subnav = 0
      this.subSubnav = 0
    },
    isHammesNav() {
      return document.querySelector('body').classList.contains('default')
    },
  },
})

app.config.compilerOptions = {
  whitespace: 'condense',
}

app.mount('#main-nav')
